module.exports = __webpack_public_path__ + "static/fee05-c5085d6258a85689e7452be9891f3dce.png";